<template>
  <ExtendedDialog
    :config="insecurePasswordDialog"
    :show-dialog="insecurePassword"
    :show-close-button="false"
    @execute-action="execute($event)"
  >
    <div class="dialog-content">
      <p>{{ $t('common.updatePassword') }}</p>
      <v-alert class="my-3" type="warning">
        {{ $t('common.insecurePassword') }}
      </v-alert>
      <p>{{ $t('common.insecurePasswordDetails') }}</p>
    </div>
  </ExtendedDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ButtonCallbacks } from '@/components/types/Dialog';
import ExtendedDialog from '@/components/common/dialog/ExtendedDialog.vue';
import { insecurePasswordDialog } from '@/models/generalDialogConfig';
import { appStore } from '@/store/pinia/AppStore';
import { mapState, mapWritableState, mapActions } from 'pinia';
import AuthApi from '@/services/auth/AuthApi';

export default defineComponent({
  name: 'InsecurePasswordDialog',
  components: {
    ExtendedDialog
  },
  emits: ['update:showDialog'],
  data() {
    return {
      insecurePasswordDialog
    };
  },
  computed: {
    ...mapWritableState(appStore, ['preOpenChangePasswordDialog']),
    ...mapState(appStore, ['insecurePassword'])
  },
  methods: {
    ...mapActions(appStore, ['setInsecurePassword']),
    async execute(callbackID) {
      if (callbackID === ButtonCallbacks.ACTION) {
        await this.$router.push('/profile');
        this.preOpenChangePasswordDialog = true;
      } else if (callbackID === ButtonCallbacks.CANCEL) {
        await AuthApi.logout();
        this.setInsecurePassword(false);
      }
    }
  }
});
</script>
